import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HttpCommonService} from '../../../../../shared/services/http-common.service';
import {Observable} from 'rxjs';
import {GenericHttpResponse} from '../../../../../shared/services/interfaces/generic-http-response.interface';
import {DatoFacturacion} from '../clientes/clientes.interface';
import {CrearDatoFacturacion, DatoFacturacionPayload} from './datos-facturacion.interface';

@Injectable({
  providedIn: 'root'
})
export class DatosFacturacionService {
  private http = inject(HttpClient);
  private httpCommonService = inject(HttpCommonService);

  show(id: number): Observable<GenericHttpResponse<DatoFacturacion>> {
    const url = this.httpCommonService.makeUrl(`/pers/datosFacturaciones/${id}`);
    return this.http.get<GenericHttpResponse<DatoFacturacion>>(url);
  }

  store(body: CrearDatoFacturacion): Observable<GenericHttpResponse<DatoFacturacion>> {
    const url = this.httpCommonService.makeUrl('/pers/datosFacturaciones');
    return this.http.post<GenericHttpResponse<DatoFacturacion>>(url, body);
  }

  update(id: number, body: DatoFacturacionPayload): Observable<GenericHttpResponse<DatoFacturacion>> {
    const url = this.httpCommonService.makeUrl(`/pers/datosFacturaciones/${id}`);
    return this.http.put<GenericHttpResponse<DatoFacturacion>>(url, body);
  }
}
